module.exports = __webpack_public_path__ + "img/KRK-min.5c99396b.png";